import React from "react";

import InvestYieldState from "./InvestYieldState";

export default function Zar8YieldDashboardState(props) {
  return <InvestYieldState {...props} variant="populated" />;
}
